<template>
    <div class="modal-choice">
        <div class="choice-container" v-if="choices.length > 0">
            <div
                v-for="(choice, index) in choices"
                :key="index"
                class="choice-wrapper"
            >
                <label :for="index">{{ choice.name }}</label>
                <input
                    type="radio"
                    :id="index"
                    name="residenceType"
                    v-model="selected"
                    :value="choice"
                />
            </div>
        </div>

        <p v-else>{{ emptyListMessage }}</p>
        <div class="button-wrapper">
            <BasicButton @click="accept(selected)" :disabled="!selected">
                {{ validateButtonText }}
            </BasicButton>
            <BasicButton @click="close" color="blue">
                {{ cancelButtonText }}
            </BasicButton>
        </div>
    </div>
</template>

<script>
import BasicButton from "@/components/basic/BasicButton.vue"
export default {
    name: "MoveTo",
    components: { BasicButton },
    props: {
        choices: {
            type: Array,
            required: true,
        },
        validateButton: {
            type: String,
            required: true,
        },
        cancelButton: {
            type: String,
            required: true,
        },
        valid: {
            type: Function,
            required: true,
        },
        refuse: {
            type: Function,
            required: false,
        },
    },
    computed: {
        validateButtonText() {
            return this.validateButton
                ? this.validateButton
                : this.$t("button.validate")
        },
        cancelButtonText() {
            return this.cancelButton
                ? this.cancelButton
                : this.$t("button.cancel")
        },
        emptyListMessage() {
            switch (this.$route.name) {
                case "ApartmentCreateOrEdit":
                    return this.$t("apartmentsList.moveTo.empty")
                default:
                    return this.$t("global.array.emptyList")
            }
        },
    },

    data() {
        return {
            selected: null,
        }
    },

    methods: {
        close() {
            if (this.refuse) {
                this.refuse()
            }
            this.closeModal()
        },

        accept(selected) {
            this.valid(selected)
            this.closeModal()
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/fontSize.scss";
.modal-choice {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1em;
    width: 100%;

    .choice-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        max-height: 300px;
        overflow-y: auto;

        .choice-wrapper {
            display: flex;
            align-items: center;
            width: 100%;
            justify-content: space-between;

            label {
                max-width: 85%;
                width: 100%;
                text-wrap: wrap;
                word-wrap: break-word;
                padding: 0.6em 0;
                &:hover {
                    cursor: pointer;
                }

                font-size: $normal;
            }

            input {
                width: 15%;
                height: 18px;
                padding: 0 1em;
                &:hover {
                    cursor: pointer;
                }
            }
        }
    }

    .button-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        gap: 2em;
    }
}
</style>
